import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { FilterClearIcon } from '../../icons';
import Colors from '../../assets/styles/variables.scss';
import './LookaheadClearFiltersButton.scss';

export const LookaheadClearFiltersButton = ({
  filterCounter,
  onCommandDispatched
}) => {
  const [show, setShow] = useState(false);
  const { DARK_MINT } = Colors;
  const { t } = useTranslation();

  useEffect(() => setShow(filterCounter > 0), [filterCounter]);

  const handleClick = () => {
    onCommandDispatched('CLEAR_LOOKAHEAD_FILTERS');
  };

  if (!show) {
    return null;
  }

  return (
    <div className="clear-filters__button" onClick={handleClick}>
      <FilterClearIcon color={DARK_MINT} size={16} />
      <span>{t('filters_label.clear_filters')}</span>
    </div>
  );
};

LookaheadClearFiltersButton.propTypes = {
  filterCounter: PropTypes.number,
  onCommandDispatched: PropTypes.func
};
